export default __webpack_public_path__ + "static/media/J7MallBack.65d46823.png";